import cookies from 'js-cookie'

export default function cookieStore(attributes = {}) {
  return function (key) {
    const KEY = `cvco.${key}`

    return {
      get() {
        const jsonStr = cookies.get(KEY)
        return jsonStr ? JSON.parse(jsonStr) : null
      },

      set(value) {
        if (!value) {
          return
        }
        cookies.set(KEY, JSON.stringify(value), attributes)
      },
    }
  }
}
